import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchProductReviewsSummaryClient } from 'src/services/product-reviews/fetchProductReviewsSummaryClient';
import type { ProductReviewsSummaryResponse } from 'src/services/product-reviews/types';
import { fetchProductReviews } from 'src/services/rar-data-api/fetchProductReviews';
import type { RarDataAPIResponse } from 'src/services/rar-data-api/types/RarDataAPIResponse';
import { fetchReviewSummary } from 'src/services/reviews-summary-api/fetchReviewSummary';
import type { ReviewSummaryResponse } from 'src/services/reviews-summary-api/types/ReviewSummaryResponse';

export interface RequestProductReviewsOptions {
  autoInitiated?: boolean;
  page: number;
  perPage?: number;
  productCode: number;
}

export const requestProductReviews = createAsyncThunk<
  RarDataAPIResponse,
  RequestProductReviewsOptions
>('productReviews/requestProductReviews', async ({ page, perPage, productCode }) => {
  const data = await fetchProductReviews(productCode, { page, perPage });

  return data;
});

export interface RequestReviewsSummaryOptions {
  productCode: number;
}

export const requestAiSummary = createAsyncThunk<
  ReviewSummaryResponse | null,
  RequestReviewsSummaryOptions
>('reviews/requestAiSummary', ({ productCode }) => fetchReviewSummary(productCode));

export const requestProductReviewsSummary = createAsyncThunk<
  ProductReviewsSummaryResponse | null,
  RequestReviewsSummaryOptions
>('reviews/requestProductReviewsSummary', ({ productCode }) =>
  fetchProductReviewsSummaryClient(productCode),
);
